module.exports = __webpack_public_path__ + "static/media/draw-polygon.9888ded8.svg";